const chargerActionTypes = {
    START_GET_CHARGERS: 'START_GET_CHARGERS',
    GET_DRIVER_CHARGER_SUCCESS: 'GET_DRIVER_CHARGER_SUCCESS',
    GET_DRIVER_CHARGER_FAILURE: 'GET_DRIVER_CHARGER_FAILURE',

    GET_PUBLIC_CHARGER_SUCCESS: 'GET_PUBLIC_CHARGER_SUCCESS',
    GET_PUBLIC_CHARGER_FAILURE: 'GET_PUBLIC_CHARGER_FAILURE',

    GET_CHARGER_SUCCESS: 'GET_CHARGER_SUCCESS',
    GET_CHARGER_FAILURE: 'GET_CHARGER_FAILURE',

    GET_ALL_CHARGERS_SUCCESS: 'GET_ALL_CHARGERS_SUCCESS',
    GET_ALL_CHARGERS_FAILURE: 'GET_ALL_CHARGERS_FAILURE',

    GET_FAVORITE_SUCCESS: 'GET_FAVORITE_SUCCESS',
    GET_FAVORITE_FAILURE: 'GET_FAVORITE_FAILURE',

    START_ADD_CHARGER: 'START_ADD_CHARGER',
    ADD_CHARGER_SUCCESS: 'ADD_CHARGER_SUCCESS',
    ADD_CHARGER_FAILURE: 'ADD_CHARGER_FAILURE',

    START_UPDATE_CHARGER: 'START_UPDATE_CHARGER',
    UPDATE_CHARGER_SUCCESS: 'UPDATE_CHARGER_SUCCESS',
    UPDATE_CHARGER_FAILURE: 'UPDATE_CHARGER_FAILURE',

    START_DELETE_CHARGER: 'START_DELETE_CHARGER',
    DELETE_CHARGER_SUCCESS: 'DELETE_CHARGER_SUCCESS',
    DELETE_CHARGER_FAILURE: 'DELETE_CHARGER_FAILURE',

    START_ADD_FAVORITE: 'START_ADD_FAVORITE',
    ADD_FAVORITE_CHARGER_SUCCESS: 'ADD_FAVORITE_CHARGER_SUCCESS',
    ADD_FAVORITE_CHARGER_FAILURE: 'ADD_FAVORITE_CHARGER_FAILURE',

    START_REMOVE_FAVORITE: 'START_REMOVE_FAVORITE',
    REMOVE_FAVORITE_CHARGER_SUCCESS: 'REMOVE_FAVORITE_CHARGER_SUCCESS',
    REMOVE_FAVORITE_CHARGER_FAILURE: 'REMOVE_FAVORITE_CHARGER_FAILURE',

    SELECT_CHARGER: 'SELECT_CHARGER',
    UNSELECT_CHARGER: 'UNSELECT_CHARGER',

    SET_MY_ACTIVE_CHARGER_ID: 'SET_MY_ACTIVE_CHARGER_ID',


    RESET: 'RESET',
    RESET_STATE_INFO: 'RESET_STATE_INFO',

    UPDATE_CHARGER_GROUP: 'UPDATE_CHARGER_GROUP',

    //signalR messages
    UPDATE_CONNECTOR_STATUS: 'UPDATE_CONNECTOR_STATUS',
    UPDATE_CHARGER_STATUS: 'UPDATE_CHARGER_STATUS',
    UPDATE_CHARGING_SUMMERY: 'UPDATE_CHARGING_SUMMERY',
    UPDATE_TRANSACTION_DATA: 'UPDATE_TRANSACTION_DATA',
    // spec 000196 — the live charging-session state: which of the four states the session is in,
    // when the grace period ends, and how much parking has accrued so far.
    UPDATE_CHARGING_SESSION_STATE: 'UPDATE_CHARGING_SESSION_STATE',
    CLEAR_CHARGING_SESSION_STATE: 'CLEAR_CHARGING_SESSION_STATE',
    // spec 000273 — the same state read from the server (screen opened / reconnected after the live frame).
    LOAD_CHARGING_SESSION_STATE: 'LOAD_CHARGING_SESSION_STATE',
    CHARGE_POINT_DETAILS_SUCCESS: 'CHARGE_POINT_DETAILS_SUCCESS',
    CHARGE_POINT_DETAILS_FAILURE: 'CHARGE_POINT_DETAILS_FAILURE',
};

export default chargerActionTypes;